import each from "lodash-es/each";
import find from "lodash-es/find";
import head from "lodash-es/head";
import map from "lodash-es/map";
import reject from "lodash-es/reject";
import { SurveyQuestion } from "./survey-models";
import { SurveySection } from "./survey-section";

export class SurveyData {
  id: number;
  name: string;
  lastQuestionActive: boolean;
  confirmedAt: string;
  introduction: string;
  instructions: string;
  outroHeader: string;
  outroText: string;
  version: number;
  allowMultiplePerPatient: boolean;
  sections: SurveySection[] = [];
  currentQuestion: SurveyQuestion;

  static fromApiV2(response): SurveyData {
    const surveyData = new SurveyData();
    surveyData.id = response.id;
    surveyData.name = response.name;
    surveyData.lastQuestionActive = false;
    surveyData.confirmedAt = response.confirmed_at;
    surveyData.introduction = response.introduction;
    surveyData.instructions = response.instructions;
    surveyData.outroHeader = response.outro_header;
    surveyData.outroText = response.outro_text;
    surveyData.version = response.current_version;
    surveyData.allowMultiplePerPatient = response.allow_multiple_per_patient;
    each(response.sections, section => {
      surveyData.sections.push(SurveySection.fromApiV2(section));
    });
    surveyData.activateNextQuestion();
    return surveyData;
  }

  activateNextQuestion() {
    const nextQuestion = this.findNextQuestion();
    if (nextQuestion != null) {
      nextQuestion.activated = true;
      this.currentQuestion = nextQuestion;
    }
    if (this.findNextQuestion() == null) {
      this.lastQuestionActive = true;
    }
  }

  clearFocusedQuestion() {
    each(this.sections, (section: any) => {
      section.focused = false;
      each(section.questions, question => {
        question.focused = false;
      });
    });
  }

  getCurrentQuestionId(): number {
    return this.currentQuestion.id;
  }

  getCurrentQuestion(): SurveyQuestion {
    return this.currentQuestion;
  }

  hasNamedSections(): boolean {
    return this.sections.filter(s => s.name != null).length > 1;
  }

  private findNextQuestion() {
    const nonActivatedQuestions = map(this.sections, section => {
      return find(section.questions, (question: SurveyQuestion) => {
        return !question.activated;
      });
    });
    return head(reject(nonActivatedQuestions, results => results == null));
  }
}
